import { fetch as apiFetch } from '../fetchWrapper/fetch';
import { API_URL } from '../constants';

export interface ExportMenuPdfPayload {
  destinations: ['MENU_PDF'];
  asset: {
    id: string;
    type: string;
  };
  venue_ids: string[];
  mealtime_id: string | null;
  menu_title: {
    mode: 'venue_name' | 'override';
    override: string | null;
  };
  price_scheme_id: string;
}

export interface ExportMenuPdfResponse {
  type: 'export';
  data: {
    event_log_id: string;
  };
}

export const exportMenuPdf = async (menuId: string, payload: ExportMenuPdfPayload): Promise<ExportMenuPdfResponse> => {
  const response = await apiFetch(`${API_URL}/menus/${menuId}/export`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error(response.statusText);
  }

  return response.json();
};
